export default __webpack_public_path__ + "static/media/liveFeedNote.6d084b4a.png";